<template>
  <div style="width: 100%;height: 100%;overflow: hidden">
    <div class="nothing-data" v-if="lastYear.length === 0"></div>
    <div style="height: 100%;width: 90%;margin: auto" id="bar" ref="wrap"></div>
  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
export default {
  name: 'indexNumberService',
  props: {
    ServicesCountWithTime: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      servicesCountWithTime: [],
      xData: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      lastYear: [],
      year: [],
      growth: [],
      year1: '',
      year2: ''
    }
  },
  created () {
    // 服务人数
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    this.year2 = new Date().format('yyyy')
    this.year1 = (parseInt(this.year2) - 1) + ''
    // console.log(this.year1, this.year2)
    this.servicesCountWithTime = this.ServicesCountWithTime
  },
  mounted () {
    this.getStartData()
  },
  methods: {
    getRefresh (arr) {
      // console.log('服务人数', arr)
      this.servicesCountWithTime = arr
      this.getStartData()
    },
    getStartData () {
      this.lastYear = []
      this.year = []
      for (let i = 0; i < this.xData.length; i++) {
        let cnt1 = 0
        let cnt2 = 0
        for (let j = 0; j < this.servicesCountWithTime.length; j++) {
          let obj = this.servicesCountWithTime[j]
          let arr = obj.monthtime.split('-')
          if (arr[1] === this.xData[i]) {
            if (arr[0] === this.year1) {
              cnt1 = obj.servicecount
            }
            if (arr[0] === this.year2) {
              cnt2 = obj.servicecount
            }
          }
        }
        this.lastYear.push(cnt1)
        this.year.push(cnt2)
      }
      this.growth = []
      for (let i = 0; i < this.lastYear.length; i++) {
        let cnt3 = 0
        if (this.year[i] === 0 || (this.year[i] - this.lastYear[i] === 0)) {
          cnt3 = 0
        } else if (this.lastYear[i] === 0) {
          cnt3 = 100
        } else {
          let num = (this.year[i] - this.lastYear[i]) / this.lastYear[i] * 100.00
          cnt3 = Math.round(num)
        }
        this.growth.push(cnt3)
      }
      let vm = this
      setTimeout(() => {
        vm.getChartData()
      }, 100)
    },
    getChartData () {
      let chart = this.$echarts.init(this.$refs.wrap)
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },

        legend: {
          data: ['去年', '今年', '同比增长(%)'],
          textStyle: {
            color: '#ffffff'
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1
              }
            },
            data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            name: '',
            interval: 20,
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: false
            }
          },
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            name: '',
            interval: 20,
            axisLabel: {
              formatter: '{value} %'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182f4d',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: '去年',
            type: 'bar',
            stack: 'overlap',
            data: this.lastYear
          },
          {
            name: '今年',
            type: 'bar',
            stack: 'overlap',
            data: this.year
          },
          {
            name: '同比增长(%)',
            type: 'line',
            yAxisIndex: 1,
            data: this.growth,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(229, 115, 0, 0.7)'
              }, {
                offset: 1,
                color: 'rgba(229, 115, 0, 0)'
              }])
            }
          }
        ],
        color: ['#caf200', '#02bbff', '#e57300']
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexNumberService.vue